import { render, staticRenderFns } from "./Konfigurator.vue?vue&type=template&id=da60c8d0&"
import script from "./Konfigurator.vue?vue&type=script&lang=js&"
export * from "./Konfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da60c8d0')) {
      api.createRecord('da60c8d0', component.options)
    } else {
      api.reload('da60c8d0', component.options)
    }
    module.hot.accept("./Konfigurator.vue?vue&type=template&id=da60c8d0&", function () {
      api.rerender('da60c8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Konfigurator.vue"
export default component.exports